import * as React from "react";

import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { PushInstance } from "../../Internals/ControlContexts/PathContexts/PushInstance";
import { useTestPageObject } from "../../Services/TestPageObjects/PageObjectExposure";
import { ProvideInstanceIndex } from "../../Internals/ControlContexts/PathContexts/InstanceIndexContext";

import { MultipleTestPageObject } from "./MultipleTestPageObject";

export interface MultipleProps {
    bindingPath: AbsoluteResolvedModelPath;
    instances: readonly string[];
    children: React.ReactNode;
    onAddInstance: () => void;
    onRemoveInstance: (bindingPath: AbsoluteResolvedModelPath, instance: string) => void;
}

export function Multiple(props: MultipleProps): JSX.Element {
    const handleRemoveInstance = (instance: string) => {
        props.onRemoveInstance(props.bindingPath, instance);
    };

    useTestPageObject(
        () => MultipleTestPageObject(props.onAddInstance, props.instances.length, handleRemoveInstance),
        [props.instances]
    );

    return (
        <>
            {props.instances.map((instance, index) => (
                <ProvideInstanceIndex key={instance} index={index} bindingPath={props.bindingPath}>
                    <PushInstance bindingPath={props.bindingPath} instance={instance}>
                        {props.children}
                    </PushInstance>
                </ProvideInstanceIndex>
            ))}
        </>
    );
}
